export default "__VITE_ASSET__DV2sYKXG__"